import { useContext } from 'react';
import { CButton, CCard, CCardBody } from '@coreui/react';

import { CustomExternalDataBody, CustomExternalDataContext } from '.';
import { CUSTOM_EXTERNAL_DATA_MODAL_STEPS } from '../../../../../../constants';

const Intro = () => {
     const { closeModal, setCurrentStep } = useContext(CustomExternalDataContext);

     const goNext = () => {
          setCurrentStep(CUSTOM_EXTERNAL_DATA_MODAL_STEPS.NAME_EXTERNAL_DATA);
     };

     return (
          <CustomExternalDataBody onBackBtnClicked={closeModal}>
               <CCard>
                    <CCardBody>
                         <h3>Create a Custom External Data</h3>
                         <p>
                              Build a custom external data if our library is missing an external data you need. This will allow you to{" "}
                              run any javascript tag on triggers, conversions, or page views that you choose while keeping your work organized.
                         </p>
                    </CCardBody>
               </CCard>

               <CButton className="btn-save" onClick={goNext}>NEXT</CButton>
          </CustomExternalDataBody>
     );
};

export default Intro;
